import { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { TESTIMONIALS as DATA } from '../../data/content';
import { TESTIMONIALS } from '../../constants/testIds';

export const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const total = DATA.length;

  useEffect(() => {
    const id = setTimeout(() => setIndex((i) => (i + 1) % total), 7500);
    return () => clearTimeout(id);
  }, [index, total]);

  const go = (i) => setIndex(((i % total) + total) % total);

  return (
    <section
      data-testid={TESTIMONIALS.root}
      className="relative bg-[#9BA58D]/15 py-24 lg:py-32 overflow-hidden"
    >
      <div className="px-6 md:px-10 lg:px-16 max-w-[1100px] mx-auto text-center">
        <div className="flex items-center justify-center gap-4 mb-10">
          <span className="w-10 h-px bg-[#A66B45]" />
          <span className="text-[11px] tracking-[0.4em] uppercase text-[#A66B45]">
            Voices from the Forest
          </span>
          <span className="w-10 h-px bg-[#A66B45]" />
        </div>

        <Quote size={56} strokeWidth={1} className="text-[#C9A458] mx-auto mb-8" />

        <div className="relative min-h-[260px] md:min-h-[220px]">
          {DATA.map((t, i) => (
            <div
              key={i}
              data-testid={TESTIMONIALS.slide(i)}
              aria-hidden={i !== index}
              className={`absolute inset-0 transition-opacity duration-700 ${
                i === index ? 'opacity-100' : 'opacity-0 pointer-events-none'
              }`}
            >
              <p className="font-serif text-[#18342A] text-2xl md:text-3xl lg:text-4xl leading-snug font-light italic">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-10 flex items-center justify-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover border border-[#C9A458]/40"
                />
                <div className="text-left">
                  <div className="font-serif text-[#18342A] text-lg leading-tight">
                    {t.name}
                  </div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#6D6A61] mt-1">
                    {t.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 flex items-center justify-center gap-4">
          <button
            type="button"
            data-testid={TESTIMONIALS.prev}
            onClick={() => go(index - 1)}
            aria-label="Previous testimonial"
            className="w-11 h-11 grid place-items-center border border-[#18342A]/30 text-[#18342A] hover:bg-[#18342A] hover:text-[#F5F1E8] hover:border-[#18342A] transition-colors"
          >
            <ChevronLeft size={18} strokeWidth={1.4} />
          </button>
          <div className="flex items-center gap-2 px-2">
            {DATA.map((_, i) => (
              <span
                key={i}
                className={`block h-px transition-all duration-500 ${
                  i === index ? 'w-10 bg-[#C9A458]' : 'w-5 bg-[#18342A]/20'
                }`}
              />
            ))}
          </div>
          <button
            type="button"
            data-testid={TESTIMONIALS.next}
            onClick={() => go(index + 1)}
            aria-label="Next testimonial"
            className="w-11 h-11 grid place-items-center border border-[#18342A]/30 text-[#18342A] hover:bg-[#18342A] hover:text-[#F5F1E8] hover:border-[#18342A] transition-colors"
          >
            <ChevronRight size={18} strokeWidth={1.4} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
